const theme = {
  colors: {
    primary: "#0f6ea2",
    transactionPrimary: "#0f6ea2",
    transactionSecondary: "#62b4de",
    white: "#fff",
    darkWhite: "#fafafa",
    gray: "#757575",
    lightGray: "#aec5d0",
    ultraLightGray: "#f2f2f6",
    orange: "#fd8b25",
    error: "#c53030",
    black: "#606060",
  },
};

export default theme;
